import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EGuideContext, EProfileTypeDTO } from '@project/view-models';
import { TranslateService } from '@project/translate';
import { UserProfileDataService } from '@project/services';
import { NotificationsService } from '@lib/notifications';

@Component({
  selector: 'app-exams-referral-guide-tab',
  templateUrl: './exams-referral-guide-tab.component.html',
  styleUrls: ['./exams-referral-guide-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExamsReferralGuidesTabComponent implements OnInit {
  logId!: string;
  context!: EGuideContext;
  selectedSubTab = 0;
  isLoading = true;

  constructor(
    private route: ActivatedRoute,
    private userProfileDataService: UserProfileDataService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private notificationsService: NotificationsService,
  ) {}
  ngOnInit(): void {
    const parentParams = this.route.parent?.snapshot.params || {};
    const currentParams = this.route.snapshot.params || {};
    this.logId = parentParams['logId'] || parentParams['id'] || currentParams['logId'] || currentParams['id'];

    if (this.logId) {
      this.resolveContext();
    } else {
      this.notificationsService.error({ message: TranslateService.localize('errors.exams-referral-guides') });
    }
  }

  private resolveContext(): void {
    this.userProfileDataService.getProfile$().subscribe((profile) => {
      const isHcAdmin = profile.profileType === EProfileTypeDTO.HealthCenterAdmin;
      const isPatientRoute = this.router.url.includes('/patients/');

      if (isHcAdmin || isPatientRoute) {
        this.context = EGuideContext.PATIENT;
      } else {
        this.context = EGuideContext.REQUISITION;
      }

      this.cdr.markForCheck();
    });
  }
}
